import { render } from "./tv_modal.vue?vue&type=template&id=7b6cf076&scoped=true"
import script from "./tv_modal.vue?vue&type=script&lang=js"
export * from "./tv_modal.vue?vue&type=script&lang=js"

import "./tv_modal.vue?vue&type=style&index=0&id=7b6cf076&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6cf076"]])

export default __exports__